import React, { useState } from 'react'
import { DropDownList } from "@progress/kendo-react-dropdowns";


const LastTenYearsDecemeberArray = () => {
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const now = new Date();
  const currentYear = now.getFullYear() - 1;
  const tenYearsAgo = currentYear - 10;
  const lastTenDecembers = [];
  for (let year = currentYear; year >= tenYearsAgo; year--) {
    let decemberLast = new Date(year, 12, 0);
    let decemberLastText = `${monthNames[decemberLast.getMonth()]} ${decemberLast.getDate()}, ${decemberLast.getFullYear()}`
    let output = { dateText: decemberLastText, dateObject: decemberLast }
    lastTenDecembers.push(output);
  }

  return lastTenDecembers;
}

export const YearDropDown = (props) => {

  const LastTenYearsDecemeber = LastTenYearsDecemeberArray();
  const [valueForDropDown, setValueForDropDown] = useState(LastTenYearsDecemeber[0]);

  const YearDropDownChanged = (e) => {
    setValueForDropDown(e.value);
    props.DropDownListChanged && props.DropDownListChanged(e);
  }

  return (
    <div>
      <DropDownList
        className='SBADropDown'
        data={LastTenYearsDecemeber}
        textField='dateText'
        onChange={YearDropDownChanged} value={valueForDropDown}
      />
    </div>
  )
}

